import { Center } from '@chakra-ui/react';
import React from 'react';
import SvgIcon from '../SvgIcon';
import svgIcons from '@/assets/svg/icons';
import colors from '@/theme/colors';

const ArrowIconUp = () => {
  return (
    <Center backgroundColor={'extra.white'} width={'20px'} height={'20px'} borderRadius={'50%'}>
      <SvgIcon
        iconPath={svgIcons.circledArrowUp}
        color={colors.extra.teal}
        additionalSvgProps={{ fillRule: 'evenodd', clipRule: 'evenodd' }}
        size={20}
      />
    </Center>
  );
};

export default ArrowIconUp;
